// extracted by mini-css-extract-plugin
module.exports = {"container":"SuccessView_container__WAf8d","title":"SuccessView_title__A6HVz","footer":"SuccessView_footer__p_B43"};